import { GetProcessStatusRequest, GetProcessStatusResponse } from "@/services/get-process-status/getProcessStatusService";

export function useProcessStatus() {
  const getProcessStatus = async (req: GetProcessStatusRequest) => {
    const result = await fetch(`/api/process-status`, {
      body: JSON.stringify(req),
      method: "POST",
    });
    const { data } = await result.json();
    const resultJson = data as GetProcessStatusResponse;
    return resultJson;
  };
  return getProcessStatus;
  
}
